import { ThemeOptions } from "vuetify/types/services/theme";
import colors from "vuetify/es5/util/colors";
import { themes } from "@/common/theme/customers";
import { Colors } from "@/common/theme/Colors";

const defaultTheme = {
  themes: {
    light: {
      primary: Colors.DarkBlue,
      secondary: Colors.Pink,
      accent: colors.lime.base,
      error: colors.pink.base,
      warning: colors.yellow.base,
      info: colors.blue.base,
      success: colors.lightGreen.base,
      chipSuccessful: colors.green.base,
      chipPending: colors.yellow.base,
      chipPaidAtPos: colors.green.lighten1,
      chipVoidAtPos: colors.grey.base,
      chipNotInitiated: colors.grey.darken2,
      chipSubmitted: colors.blue.lighten1,
      chipPicked: colors.blue.darken1,
      chipCollected: colors.green.base,
      chipCancelled: colors.grey.darken2,
      chipClickAndCollect: colors.deepPurple.lighten1,
      chipDelivery: colors.deepOrange.lighten1,
      chipUrgent: colors.red.base,
      chipDefault: colors.brown.base,
      chipText: colors.shades.white,
      chipAgeRestriction: colors.red.base,
      buttonText: colors.shades.white,
      buttonNo: colors.grey.darken2,
      buttonClose: colors.grey.darken2,
    },
  },
};

export function getThemeOptions(theme: string): ThemeOptions {
  return {
    themes: {
      light: {
        ...defaultTheme.themes.light,
        ...themes[theme]?.themes?.light,
      },
    },
  };
}
